"use strict";
export function includeIf(condition, value) {
  if (condition) {
    return value;
  }
  if (Array.isArray(value)) {
    return [];
  }
  return {};
}
